import React from 'react';
import PropTypes from 'prop-types';

class ChooseATemplate extends React.Component {
  change(template) {
    this.props.onChange('template', template);
  }

  render() {
    const template = this.props.template;
    const { plain, background, sign } = this.props.thumbnails;

    return (
      <div className="step-container step-three">
        <div>
          <h2>{'Choose a template'}</h2>
          <p>
            {
              "Use one of these templates as a jumping off point. You'll be able to customize your error pages further on the next page."
            }
          </p>
          <ul>
            <li
              onClick={this.change.bind(this, 'plain')}
              className={template === 'plain' ? 'selected' : null}
            >
              <img src={plain} alt="Plain template" />
            </li>
            <li
              onClick={this.change.bind(this, 'background')}
              className={template === 'background' ? 'selected' : null}
            >
              <img src={background} alt="Background template" />
            </li>
            <li
              onClick={this.change.bind(this, 'sign')}
              className={template === 'sign' ? 'selected' : null}
            >
              <img src={sign} alt="Sign template" />
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

ChooseATemplate.propTypes = {
  template: PropTypes.string,
};

export default ChooseATemplate;
